
import { Component, Inject, ViewChild, OnInit, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap, ActivatedRouteSnapshot } from '@angular/router';
import { Response } from '@angular/http';
import { NgForm, FormControl } from '@angular/forms';

import { Cliente } from '../cliente.model';
import { NavigationService } from '../../shared-services/navigation.service';
import { Telefono } from '../../security/user/telefono.model';
import { Email } from '../../security/user/email.model';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { EstadoCliente } from '../estadoCliente.model';
import { OperationalParametric } from '../operationalParametric.model';
import { Direccion } from '../direccion.model';

import { PaisCliente } from '../paisCliente.model';
import { TelefonoCliente } from '../telefonoCliente.model';
import { EmailCliente } from '../emailCliente.model';
import { Documento } from '../documento.model';
import { MontoCompra } from '../montoCompra.model';
import { OperationalDepartamento } from '../operationalDepartamento.model';
import { OperationalProvincia } from '../operationalProvincia.model';
import { Documentacion } from '../documentacion.model';
import { ClienteService } from '../../core/cliente.service';
import { Logo } from '../logo.model';
import { Subcliente } from '../subcliente.model';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { Sector } from '../sectores/sector.model';
import { Observable } from 'rxjs/Observable';

export class ResultSubclienteResolver {
  subcliente: Subcliente;
  padre: Cliente;
}

@Component({
  selector: 'app-cliente-user-add-edit',
  templateUrl: './cliente-user-add-edit.component.html',
  styleUrls: ['./cliente-user-add-edit.component.scss']
})

export class ClienteUserAddEditComponent implements OnInit {
  @ViewChild('clienteForm') public clienteForm: NgForm;

  public info: ResultSubclienteResolver;



  private hash: string;
  padre: Cliente;
  private documentacionRespaldatoria: Documentacion[];
  validationFail = false;
  emailPrincipalFail = false;
  private montoCompraFail = false;
  private montoCompraTipoMonedaFail = false;
  EstadoCliente = new EstadoCliente();
  PaisCliente = new PaisCliente();
  private TelefonoCliente = new TelefonoCliente();
  private EmailCliente = new EmailCliente();
  selected = new FormControl(0);
  sectores: Sector[];
  private padreId: number;
  subcliente = {id: NaN,
    username: '',
    password: '',
    retryPassword: '',
    clientePadreId: NaN,
    sector: null,
    pagaEnvio: false,
    email: {
      direccion: '',
      principal: true,
      tipoEmailId: NaN}};

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private navigationService: NavigationService,
    private snackService: SnackService,
    private backendService: BackendService,
    private dialogService: DialogService,
    clienteService: ClienteService,
    private formValidatorService: FormValidatorService,
  ) { }


  async ngOnInit() {

    this.route.data.subscribe(data => {

      this.info = data.cliente;

    });

    this.padre = this.info.padre;
    if (this.info.subcliente) {
      this.subcliente.id = this.info.subcliente.id;
      this.subcliente.username = this.info.subcliente.username;
      this.subcliente.email.direccion = this.info.subcliente.email.direccion;
      this.subcliente.email.tipoEmailId = this.info.subcliente.email.tipoEmailId;
      this.subcliente.sector = this.info.subcliente.sector;
      this.subcliente.pagaEnvio = this.info.subcliente.pagaEnvio;
    }
    this.getSectores();
  }

  back() {
    this.navigationService.back();
  }

  async getSectores() {
    this.backendService.get(Sector, Sector.path + 'all', {}).toPromise().then( d => {
      this.sectores = d;
      if(this.sectores.findIndex(s => s.id === this.subcliente.sector.id) === -1) {
        this.sectores.push(this.subcliente.sector);
      }
    });
  }

  async confirmSave() {
    if (this.validateForm()) {
      this.dialogService.confirm(this.subcliente.id ? 'Edición de cliente' : 'Alta de usuario',
      '¿Está seguro que desea guardar el cliente ' + this.subcliente.username + '?')
      .then( res => {
        if (res) {
          this.saveCliente(res);
        }
      });
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (!this.formValidatorService.isFormValid(this.clienteForm) || !this.subcliente.sector) {
      validationsOK = false;
      this.validationFail = true;
    } else {
      validationsOK = true;
      this.validationFail = false;
    }


    if (this.subcliente.password && this.subcliente.password !== this.subcliente.retryPassword) {
      this.snackService.error('Las contraseñas no coinciden');
      validationsOK = false;
    }

    return validationsOK;
  }

  async saveCliente(res) {

    if (res) {

      this.snackService.spinner(true);
      if (this.subcliente.id) { // Update
        try {
          await this.backendService.update(Subcliente.path + this.subcliente.id, this.subcliente);
          this.snackService.success('Cliente editado satisfactoriamente');
          this.navigationService.back();
          // this.router.navigate(['/clientes/detalles/' + this.subcliente.id]);
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          this.subcliente.clientePadreId = this.padre.id;
          const response = await this.backendService.createWithResponse(Subcliente.path + 'save', this.subcliente);

          const clienteResponse = JSON.parse((response as Response).text());
          this.navigationService.back();
          // this.router.navigate(['/clientes']);
          this.snackService.success('Cliente creado satisfactoriamente');
        } catch (ex) {
          if (ex[0]) {
            this.snackService.error(ex[0].details);
          } else if (ex.errors) {
            this.snackService.error(ex.errors[0].defaultMessage);
          } else {
            this.snackService.error(ex.message);
          }
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 ? c1.id === c2.id : c1 === c2;
  }

}



// WEBPACK FOOTER //
// ./src/app/cliente/cliente-user-add-edit/cliente-user-add-edit.component.ts